module.exports = __webpack_public_path__ + "media/images/product/f_c-63379329af2305c37850708d1dfed2a1.png";